import { User, Merchant } from '@stax-core/types-omni';
import { AuthDatum, AuthAction, AuthActionType } from './Auth.types';

export function updateAuth(payload: AuthDatum[]): AuthAction {
  return { type: AuthActionType.UPDATE_AUTH, payload };
}

export function removeAuth(): AuthAction {
  return { type: AuthActionType.REMOVE_AUTH };
}

export function updateAuthUser(payload: User): AuthAction {
  return { type: AuthActionType.UPDATE_AUTH_USER, payload };
}

export function updateAuthMerchant(payload: Merchant): AuthAction {
  return { type: AuthActionType.UPDATE_AUTH_MERCHANT, payload };
}

export function updateAuthIndex(payload: number): AuthAction {
  return { type: AuthActionType.UPDATE_AUTH_INDEX, payload };
}
